










































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import PluginComponent from '../PluginComponent';
import { EventBus, EVENTS } from '@/services/EventBus';
import LayerConfig from '@/models/map-context/LayerConfig';
import axios from 'axios';
import { GeoJSON } from 'ol/format';
import LayerAttribute from '@/models/map-context/LayerAttribute';
import sanitizeHtml from 'sanitize-html';
import Filter from '@/models/map-context/filter/Filter';
import FormTextInput from '@/components/shared/FormTextInput.vue';
import { Feature } from 'ol';
import { LinearRing, LineString, MultiLineString, MultiPoint, MultiPolygon, Point, Polygon } from 'ol/geom';
import { buffer } from 'ol/size';
import { createEmpty, extend } from 'ol/extent';
import { Layer } from 'ol/layer';
import AbstractLayerTreeElement from '@/models/map-context/AbstractLayerTreeElement';
import * as jsts from 'jsts';

interface FeatureCfg extends Feature {
  layerConfig?:any
}


@Component<SearchPluginCustom>({
  props: {

  },
  components: {
    FormTextInput
  },
})

export default class SearchPluginCustom extends PluginComponent {

  dataList = [{ item: 'occupations', name: 'Occupations', is3d: true },
  { item: 'objectifs', name: 'Objectifs', is3d: true },
  { item: 'projets', name: 'Projets', is3d: true }];

  static ID = 'SearchPluginCustom';

  static NAME = 'SearchPluginCustom';

  private currentFeature: any;

  isFeatureSelected = false;

  idoc = 51;

  public layer: any;

  movable = false;

  public keys = Array<any>();

  public serviceResonse: any;

  plugins: Plugin[] = [];

  public layerOfFeature: LayerConfig | null = null;

  public edition = false;

  public width = 0;

  modalLeft = 0;

  modalTop = 120;

  public urlApi = "";
  public urlMetier = "";

  public urlOriginIframe = "";

  public serviceApi = "";

  public serviceApiEdit = "";

  public infosContent = '';

  public keysForEdition = Array<any>();

  public isAccordionOpen: boolean = false;

  public featuresOccupation:any;
  public featuresObjectif:any;
  public featuresProjet:any;

  public contrats: any;
  public filtercontrats: any;
  public resultats: any=[];
  public clients: any;
  public etatcontrats: any;
  public sites: any;
  public secteuractivites: any;
  public objectifs: any;
  public filterobjectifs: any;
  public thematiques: any;
  public motcles: any;
  public responsables: any;
  public projets: any;

  public dataType = "occupations";


  public filterOccId = "";
  public filterOccClient = "";
  public filterOccEtat = "";

  public filterObjNom = "";
  public filterObjThematique = "";
  public filterObjMotcle = "";
  public filterObjResponsable = "";


  public filterProjNom = "";
  public filterProjObjectif = "";
  public filterProjThematique = "";
  public filterProjMotcle = "";
  public filterProjResponsable = "";


  parser:any;

  beforeDestroy(): void {

  }

  async created() {
    console.log('createdssss');

    const plugin = this.pluginService.getByName(SearchPluginCustom.NAME); //FeatureInfosPanelCustom
    if (plugin) {
      this.urlApi = plugin.getParameterValue('urlApi');
      this.urlMetier = plugin.getParameterValue('urlMetier');
    }

    this.callService("contrats");
    this.callService("clients");
    this.callService("etatcontrats");
    this.callService("sites");
    this.callService("secteuractivites");
    this.callService("objectifs");
    this.callService("thematiques");
    this.callService("motcles");
    this.callService("responsables");
    this.callService("projets");

    this.getMapService().zoomToInitialExtent();

    this.featuresOccupation=this.getFeatures("Toutes les occupations");
    this.featuresObjectif=this.getFeatures("objectifs");
    this.featuresProjet=this.getFeatures("projets");



    this.onChangeData(null);
  }

  mounted() {

    this.parser = new jsts.io.OL3Parser();
      this.parser.inject(
        Point,
        LineString,
        LinearRing,
        Polygon,
        MultiPoint,
        MultiLineString,
        MultiPolygon,
      );



  }



  open() {

  }


  init() {
    this.filterOccId = "";
    this.filterOccClient = "";
    this.filterOccEtat = "";
    this.filterObjNom = "";
    this.filterObjThematique = "";
    this.filterObjMotcle = "";
    this.filterObjResponsable = "";
    this.filterProjNom = "";
    this.filterProjObjectif = "";
    this.filterProjThematique = "";
    this.filterProjMotcle = "";
    this.filterProjResponsable = "";

    this.onChangeData(null);
  }

  getFeatures(title:String) {

    var features:any;
    //const l
    // ayer= this.contextService.getCurrentContext().getLayerByUid("d1393028-b7d7-462b-b28a-02f8638adec2");

    //const layer= this.contextService.getCurrentContext().getLayerByUid("c5d88615-c6fb-440c-afda-27cae6461022");

    //const abstractLayer = this.contextService.getCurrentContext().getLayers().find((v:AbstractLayerTreeElement) => v.title === 'occupations');
    //const abstractLayer = this.contextService.getCurrentContext().getLayers().find((v:AbstractLayerTreeElement) => v.title === title);

    this.contextService.getCurrentContext().getLayers().forEach((feature) => {
      //console.log(feature.title);
        }
      )   ;


    //if (abstractLayer){
      //const layer= this.contextService.getCurrentContext().getLayerByUid(abstractLayer?.uid);
      const layer= this.contextService.getCurrentContext().getLayerByUid("d1393028-b7d7-462b-b28a-02f8638adec2");
      console.log(layer?.uid);
      if (layer){
      layer.visible=true;
      layer.setVisible(true);

      console.log(layer.getLayerSource().getFeatures());
      features = layer.getLayerSource().getFeatures();

      //const extent = this.getMapService().getMapExtent();
      //this.featuresOccupation =  layer.getOlLayer().getFeaturesInExtent(extent);

      //this.featuresOccupation = await layer.getOlLayer().getAllFeatures();
      console.log(this.featuresOccupation);
        return features;
  //}

  }



  }


  onChangeData(event: any) {
    var that = this;
    var elementOK = true;

    that.resultats = [];
    if (this.dataType == 'occupations') {
      var resultatstmp=[];
      for (let i = 0; i < this.contrats.length; i += 1) {
        if (that.testValue(this.filterOccId, this.contrats[i].numero)
          && that.testValue(this.filterOccClient, this.contrats[i].idClient)
          && that.testValue(this.filterOccEtat, this.contrats[i].idEtatContrat)) {
            resultatstmp.push(this.contrats[i]);
        }
      }
      this.resultats=resultatstmp;
    }


    if (this.dataType == 'objectifs') {
      var resultatstmp=[];
      for (let i = 0; i < this.objectifs.length; i += 1) {
        if (that.testValueList(this.filterObjThematique, this.objectifs[i].thematiques)
          && that.testValueList(this.filterObjMotcle, this.objectifs[i].motCles)
          && that.testValue(this.filterObjResponsable, this.objectifs[i].idResponsable)) {
            resultatstmp.push(this.objectifs[i]);
        }
      }
      this.resultats=resultatstmp;
    }



    if (this.dataType == 'projets') {
      var resultatstmp=[];
      for (let i = 0; i < this.projets.length; i += 1) {

        if (

          that.testValueText(this.filterProjNom, this.projets[i].libelle)
          && that.testValueList(this.filterProjThematique, this.projets[i].thematiques)
          && that.testValue(this.filterProjObjectif, this.projets[i].idObjectif)
          && that.testValueList(this.filterProjMotcle, this.projets[i].motCles)
          && that.testValue(this.filterProjResponsable, this.projets[i].idResponsable)) {
            resultatstmp.push(this.projets[i]);
        }
      }
      this.resultats=resultatstmp;
    }


  }

  testValueText(filterValue: string, val: any): boolean {
    var elementOK = false;
    if (filterValue != "") {
      if (val.toLowerCase().indexOf(filterValue.toLowerCase())>-1){
        elementOK = true;
      }
    }
    else {
      elementOK = true;
    }
    return elementOK;
  }



  testValueList(filterValue: string, val: any): boolean {
    var elementOK = false;
    if (filterValue != "") {

      for (let i = 0; i < val.length; i += 1) {
        if (val[i] == filterValue)
        elementOK = true;
        }

    }
    else {
      elementOK = true;
    }
    return elementOK;
  }


  testValue(filterValue: string, val: string): boolean {
    var elementOK = false;
    if (filterValue != "") {

      if (val == filterValue)
        elementOK = true;
    }
    else {
      elementOK = true;
    }
    return elementOK;
  }

  callService(serviceName: string): any {

    var that = this;
    var xmlhttp = new XMLHttpRequest();

    var serviceResonse;

    xmlhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        serviceResonse = JSON.parse(this.responseText);
        switch (serviceName) {
          case "contrats":
            that.contrats = serviceResonse;
            that.contrats.sort((a: { numero: number; }, b: { numero: number; }) => a.numero - b.numero);
            break;
          case "clients":
            that.clients = serviceResonse;
            break;
          case "etatcontrats":
            that.etatcontrats = serviceResonse;
            break;
          case "sites":
            that.sites = serviceResonse;
            break;
          case "secteuractivites":
            that.secteuractivites = serviceResonse;
            break;
          case "contrats":
            that.contrats = serviceResonse;
            break;
          case "sites":
            that.sites = serviceResonse;
            break;
          case "objectifs":
            that.objectifs = serviceResonse;
            break;
          case "thematiques":
            that.thematiques = serviceResonse;
            break;
          case "motcles":
            that.motcles = serviceResonse;
            break;
          case "responsables":
            that.responsables = serviceResonse;
            break;
          case "projets":
            that.projets = serviceResonse;
            that.projets.sort((a: { idProjet: number; }, b: { idProjet: number; }) => a.idProjet - b.idProjet);
            break;


        }


      }
    };

    //AOT en cours
    //AOT_enCours
    //contrats
    //clients
    //etatcontrats
    //sites
    //secteuractivites

    //Toutes les occupations
    //ToutesOccupations
    //contrats
    //clients
    //etatcontrats
    //sites
    //secteuractivites

    //Objectif
    //objectif_point objectif_line objectif_polygon
    //objectifs
    //thematiques
    //motcles
    //responsables

    //Projet/Etude Projet 2
    //projet_point projet_line projet_polygon
    //projets
    //objectifs
    //responsables
    //thematiques
    //motcles


    xmlhttp.open("GET", this.urlApi + serviceName + "/", false);
    xmlhttp.send();
    console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee");
    console.log(this.serviceApi);

  }


  getCustomStyle(movable: boolean, width: number) {
    let r;
    if (movable) {
      r = `left:${this.modalLeft}px;top:${this.modalTop}px`;
    } else {
      r = 'height:100%';
    }
    if (width > 0) {
      r += `;width:calc(${width}vw - 50px);`
    }
    return r;
  }

  getClientValue(id:number) :String{
    for (let i = 0; i < this.clients.length; i += 1) {
      if (this.clients[i].idClient==id){
        return this.clients[i].libelle;
      }

    }
    return "";
  }

  getEtatValue(id:number) :String{
    for (let i = 0; i < this.etatcontrats.length; i += 1) {
      if (this.etatcontrats[i].etatId==id){
        return this.etatcontrats[i].etatLibelle;
      }

    }
    return "";
  }

  getObjectifValue(id:number) :String{
    for (let i = 0; i < this.objectifs.length; i += 1) {
      if (this.objectifs[i].idObjectif==id){
        return this.objectifs[i].libelle;
      }

    }
    return "";
  }

  getResponsableValue(id:number) :String{
    for (let i = 0; i < this.responsables.length; i += 1) {
      if (this.responsables[i].idResponsable==id){
        return this.responsables[i].libelleResponsable;
      }

    }
    return "";
  }

  getThematiqueValue(id:number) :String{
    for (let i = 0; i < this.thematiques.length; i += 1) {
      if (this.thematiques[i].idThematique==id){
        return this.thematiques[i].libelle;
      }

    }
    return "";
  }

  zoomTo(id:number){
    console.log(id);
    //for (let i = 0; i < this.featuresOccupation.length; i += 1) {



      let urlGetFeaturePrefixe= this.contextService.configuration.geoserver_api_url + "gpmg/wfs?service=wfs";

      let layernames: string[]=[];
      let queryField="";

      if (this.dataType == 'occupations') {
        layernames=["gpmg:ToutesOccupations"];
        queryField="numero";

      }


      if (this.dataType == 'objectifs') {
        layernames=["gpmg:objectif_point","gpmg:objectif_line","gpmg:objectif_polygon"];
        queryField="id_objectif";

      }

      if (this.dataType == 'projets') {
        layernames=["gpmg:projet_point","gpmg:projet_line","gpmg:projet_polygon"];
        queryField="id_projet";

      }

      layernames.forEach((layername:string) => {
        const urlGetFeature=urlGetFeaturePrefixe + "&version=2.0.0&request=GetFeature&typeName=" + layername + "&outputFormat=application/json&srsname=EPSG:3857&CQL_FILTER="+ queryField + "%3D" + id;

        axios.get(urlGetFeature).then((reponse:any) => {
          let allFeatures:any=[];
          if (reponse.data.features){
            if (reponse.data.features.length>0){

              allFeatures = new GeoJSON().readFeatures(reponse.data);
              console.log(allFeatures);
              let fitValue:any;
              if (allFeatures.length >0) {
                fitValue = allFeatures[0].getGeometry();
                if (fitValue && fitValue.getType() === 'Point') {
                  const jstsGeom = this.parser.read(fitValue);
                  const buffered = jstsGeom.buffer(500); // create a buffer of X meters
                  fitValue = this.parser.write(buffered);
                }
                this.getOpenLayersMapService().map.getView().fit(fitValue);


              }

            }

          }

          //this.getMapService().zoomToExtent(allFeatures[0].getExtent());
          // voir s'il faut zoomer sur le resultat
        }, (error) => {
          console.log(error);
          if (error.response && (error.response.data instanceof String || typeof error.response.data === 'string')
                      && error.response.data.indexOf('Could not parse CQL filter list') > 0) {

                      EventBus.$emit(EVENTS.ERROR, 'Problème dans le filtre CQL. Vérifiez la synthaxe de votre filtre');
            }else{
                      EventBus.$emit(EVENTS.ERROR, 'Problème de chargement des objets. Vérifiez que vous avez les droits de téléchargement sur cette couche');
              }

        });

      });




      //   const featuresSelected = this.featuresOccupation.filter((feature: Feature):boolean => {
      //     const tt=feature.get('numero');
      //     if (feature.get('numero')!=id){
      //       return false;
      //     }
      //     return true;
      //   });

      // let fitValue:any;
      // if (featuresSelected.length >0) {
      //   fitValue = featuresSelected[0].getGeometry();
      //   if (fitValue && fitValue.getType() === 'Point') {
      //     const jstsGeom = this.parser.read(fitValue);
      //     const buffered = jstsGeom.buffer(500); // create a buffer of X meters
      //     fitValue = this.parser.write(buffered);
      //   }
      //   this.getOpenLayersMapService().map.getView().fit(fitValue);


      // }



    //}

  }

  viewFiche(id:number,type:string){
    const url=this.urlMetier + type + "/" + id + "/view";
    this.openInNewTab(url);
  }

  editFiche(id:number,type:string){
    const url=this.urlMetier + type + "/" + id + "/edit";
    this.openInNewTab(url);
  }

  openInNewTab(url: string) {
    if(url){
      window.open(url, '_blank');
    }
  }
}
